import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';
import { Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';

import { environment } from '../../environments/environment';
import { APIURLS, SEARCHVIEWLABELS, SHAREDCONSTANTS } from '../_constants/constants';
import { LookUpResult, SearchResult } from './../_models/data.structures';
import { NotificationDialogComponent } from './../notification/notification.dialog.component';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { TranslateService } from '../_services/translate.service';
import { TranslatePipe } from '../shared/translate/translate.pipe';

import {Subject} from 'rxjs/Subject';



@Injectable()
export class SearchService {
    private lookupresult: LookUpResult;
    private pending = false;
    search: any;

    nameChange: Subject<string> = new Subject<string>();

    constructor(private router: Router, private http: Http, private translate: TranslateService) {
        this.search = "";
    }

    changeSearchValueOfSearchComponent(){

        let lastSearchData = JSON.parse(localStorage.getItem('searchData'));

        if(Object.keys(lastSearchData).length !== 0){

          if(lastSearchData.hasOwnProperty('searchStr')){
            this.nameChange.next(lastSearchData['searchStr']);
          }
        }
    }


    getDataForList(searchValue: string, verifiedOnly: boolean, opcoValue: string, ds: DialogService) {
        const params = new URLSearchParams();
        const phoneQueryKey = 'qphone_number';
        const emailQueryKey = 'qemail';
        let queryKey;
        const URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Lookup);
        document.getElementById("searchInput").blur();
        document.getElementById("searchSubmitButtonId").blur();
        searchValue = searchValue.trim();
        if(searchValue.length < 2 && !(/^\*{1,2}$/).test(searchValue)){
             ds.addDialog(NotificationDialogComponent, {
                success: false,
                message: SHAREDCONSTANTS.MIN_TWO_CHARACTER
            });
            return;
        }
        if(searchValue != "" && ((/^[0-9]+$/).test(searchValue) || (/^[0-9]+\*$/).test(searchValue) || (/^\*[0-9]+$/).test(searchValue) || (/^\*[0-9]*\*+$/).test(searchValue)) ){
            //searchValue = (/^[0-9]+$/).test(searchValue) === true ? '*' + searchValue + '*' : searchValue;
            if((/^[0-9]+$/).test(searchValue) === true && searchValue.length < 5){
                searchValue = '*' + searchValue + '*';
            }
            queryKey = phoneQueryKey;
        }else if (searchValue != "" && (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(searchValue) || /^[a-zA-Z0-9_.-]*$/.test(searchValue) || /^[a-zA-Z0-9_.-]*\*$/.test(searchValue) || /^\*[a-zA-Z0-9_.-]*\*$/.test(searchValue) || /^\*[a-zA-Z0-9_.-]*$/.test(searchValue))){
            searchValue = (/^[a-zA-Z0-9_.-]*$/).test(searchValue) === true ? '*' + searchValue + '*' : searchValue;
            queryKey = emailQueryKey;
        }else{
            ds.addDialog(NotificationDialogComponent, {
                success: false,
                message: SEARCHVIEWLABELS.LETTER_SEARCH_ERROR
            });
            return;
        }
        if (verifiedOnly !== undefined && verifiedOnly) {
            params.append(queryKey + '_verified', 'true');
        }

        this.pending = true;
        params.append(queryKey, searchValue);
        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');

        const requestOptions = new RequestOptions({ search: params, headers: headers, withCredentials: true });
        this.http.get(URL, requestOptions).subscribe(
            data => {
                this.lookupresult = data.json();
                this.pending = false;
            },
            err => {
                this.pending = false;
                if (err.status === 400) {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: SEARCHVIEWLABELS.ILLEGAL_FORMAT_ERROR
                    });
                } else if(err.status === 401){
                    window.location.href = '/';
                }
                else if(err.json().code == "IDP_ERROR"){
                        ds.addDialog(NotificationDialogComponent, {
                            success: false,
                            message: err.json().message
                        });
                }
                else {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: SHAREDCONSTANTS.COMMON_ERROR_MESSAGE
                    });
                }
            },
            () => {
                if (this.lookupresult.items.length < 1) {
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: SEARCHVIEWLABELS.NO_DATA_FOUND_ERROR
                    });
                }
            }
        );

    }



    deleteCustomer(subValue: string, opcoValue: string, ds: DialogService) {

            this.pending = true;

            const URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update).replace('{sub}', subValue);
            const headers = new Headers();
            headers.append('x-int-opco-id', opcoValue);
            const options = new RequestOptions({ headers: headers, withCredentials: true });

            return this.http.delete(URL, options).map(response => response);

    }

    deleteSub(subValue: string, opcoValue: string, ds: DialogService) {

            this.pending = true;

            const URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update).replace('{sub}', subValue);
            const headers = new Headers();
            headers.append('x-int-opco-id', opcoValue);
            const options = new RequestOptions({ headers: headers, withCredentials: true });
            this.http.delete(URL, options).subscribe(data => {
                let itemsEntry: SearchResult;
                for (const searchresult of this.lookupresult.items) {
                    if (searchresult.sub === subValue) {
                        itemsEntry = searchresult;
                        break;
                    }
                }
                const index = this.lookupresult.items.indexOf(itemsEntry, 0);
                if (index > -1) {
                    this.lookupresult.items.splice(index, 1);
                }
                this.pending = false;
            },
            err => {
                this.pending = false;
                ds.addDialog(NotificationDialogComponent, {
                    success: false,
                    message: SHAREDCONSTANTS.COMMON_ERROR_MESSAGE
                }
                );
            });

    }

    getDataForLink(link: string, opcoValue: string, ds: DialogService) {
        this.pending = true;
        const headers = new Headers();
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');
        headers.append('x-int-opco-id', opcoValue);
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        this.http.get(link, options).subscribe(
            data => {
                this.lookupresult = data.json();
                this.pending = false;
            },
            err => {
                this.pending = false;
                ds.addDialog(NotificationDialogComponent, {
                    success: false,
                    message: SHAREDCONSTANTS.COMMON_ERROR_MESSAGE
                });
            }
        );
    }

    getLookUpResult(): LookUpResult {
        return this.lookupresult;
    }

    isPending(): boolean {
        return this.pending;
    }


    allEqual(input) {
        return input.split('').every(char => char === input[0]);
    }

    saveUpdatedUser( subValue: string, opcoValue: string,etagValue: string ) {
        let URL;
        let payload;
        if(opcoValue == 'ro') {
            payload ="{\"status\":\"DELETED\"}";
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_Ro).replace('{sub}',subValue);
        }
        else if(opcoValue == 'vo') {
            payload ="{\"status\":\"TERMINATED\"}";
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_Vo).replace('{sub}',subValue);
        }
        else if(opcoValue == 'al') {
            payload ="{\"status\":\"DELETED\"}";
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_Al).replace('{sub}',subValue);
        }
        else if(opcoValue == 'cz') {
            payload ="{\"status\":\"DELETED\"}";
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_Cz).replace('{sub}',subValue);
        }
        else if(opcoValue == 'it') {
            payload ="{\"status\":\"DELETED\"}";
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Details_Update_It).replace('{sub}',subValue);
        }
        
        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('Content-Type', 'application/merge-patch+json');
        headers.append('If-None-Match', etagValue);
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        console.log("Save date: " + payload);
        this.http.patch(URL, payload, options).subscribe(
            response => {
                //DetailsComponent.decrementRunningRequests();

            },
            err => {

                 console.log(err);
            },
            () => {
                setTimeout(()=> {


                }, 1000);

            }
        );

    }


    getCustomersData(page: number,searchValue: string, dropValue: string, verifiedOnly: boolean, activeOnly: boolean, opcoValue: string, selectedCountry:string, ds: DialogService, itemsPerPage:number, offset:number, status:string): Observable<any> {
        const params = new URLSearchParams();
        const phoneQueryKey = 'qphone_number';
        const emailQueryKey = 'qemail';

        let queryKey;
        let URL;

        if(opcoValue === 'ro' || opcoValue === 'vo' || opcoValue === 'al'|| opcoValue === 'cz' || opcoValue === 'it'  ){
            if (opcoValue === 'ro') {
                URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Lookup_Ro);
            }
            if (opcoValue === 'al' ) {
                URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Lookup_AL);
            }
            if (opcoValue === 'cz' ) {
                URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Lookup_CZ);
            }
            if (opcoValue === 'it' ) {
                URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Lookup_IT);
            }
            if (opcoValue === 'vo') {
                URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Lookup_Vo);
            }
            searchValue = searchValue.trim();
            queryKey = dropValue;
            
            if (activeOnly !== undefined && activeOnly) {
                //params.append(queryKey + '_active', 'true');
               // console.log(activeOnly)
            }else{
                params.append("status", String(status));
              //  console.log(typeof(activeOnly),'vvv')
            }

        }
	// Blocking NL check due to VICC-1357 Bad Request error
        //else  if(opcoValue==='nl'){
        //    URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Lookup);
        //    queryKey=phoneQueryKey;
        //    if (verifiedOnly !== undefined && verifiedOnly) {
        //        params.append(queryKey + '_verified', 'true');
        //    }
        //}
        else{
            
            URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_Search_Lookup);
            searchValue = searchValue.trim();
            if (searchValue.length < 2 && !(/^\*{1,2}$/).test(searchValue)) {
                this.changeSearchValueOfSearchComponent();
                ds.addDialog(NotificationDialogComponent, {
                    success: false,
                    message: new TranslatePipe(this.translate).transform('MIN_TWO_CHARACTER', 'SHAREDCONSTANTS')
                });
                return Observable.empty();
            }
            if (searchValue != "" && ((/^[0-9]+$/).test(searchValue) || (/^[0-9]+\*$/).test(searchValue) || (/^\*[0-9]+$/).test(searchValue) || (/^\*[0-9]*\*+$/).test(searchValue))) {

                if ((/^[0-9]+$/).test(searchValue) === true && searchValue.length < 5) {
                    searchValue = '*' + searchValue + '*';
                }

                queryKey = phoneQueryKey;


            } else if (searchValue != "" && (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(searchValue) || /^[a-zA-Z0-9_.-]*$/.test(searchValue) || /^[a-zA-Z0-9_.-]*\*$/.test(searchValue) || /^\*[a-zA-Z0-9_.-]*\*$/.test(searchValue) || /^\*[a-zA-Z0-9_.-]*$/.test(searchValue))) {
                searchValue = (/^[a-zA-Z0-9_.-]*$/).test(searchValue) === true ? '*' + searchValue + '*' : searchValue;

                queryKey = emailQueryKey;

            } else {

                this.changeSearchValueOfSearchComponent();

                ds.addDialog(NotificationDialogComponent, {
                    success: false,
                    message: new TranslatePipe(this.translate).transform('LETTER_SEARCH_ERROR', 'SEARCHVIEWLABELS')
                });
                return Observable.empty();
            }
            if (verifiedOnly !== undefined && verifiedOnly) {
                params.append(queryKey + '_verified', 'true');
            }
        }

        this.pending = true;
        params.append(queryKey, encodeURIComponent(searchValue));
        params.append("offset", String(offset));
        params.append("count", String(itemsPerPage));

        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');

        if (selectedCountry !== undefined) {
            headers.append('x-int-opco-header', selectedCountry);
            // headers.append('x-vf-trace-nv_opco_id', opcoValue+"-"+selectedCountry);
            params.append("qcountry", selectedCountry);
        }
        console.log(params);
        const requestOptions = new RequestOptions({ 
            search: params, headers: headers, withCredentials: true });
        return this.http.get(URL, requestOptions).map(response => response.json());

    }
}



// WEBPACK FOOTER //
// ./src/app/_services/search.service.ts